/**
 * index module
 * @module
 * @see module:src/jockey__cheniu
 * @see module:src/jockey__dafengche
 */
var is = require('@souche-f2e/chunyan-util/sc-is/is-c');
var jockey__cheniu = require('./src/jockey__cheniu.js');
var jockey__dafengche = require('./src/jockey__dafengche.js');

/** [getData description] */
var getData = function () {
	return $.when({}).then(function () {
		if (is.cheniu()) {
			return jockey__cheniu.getUser().then(function (user) {
				return $.when(jockey__cheniu.getCore(), user);
			}).then(function (core, user) {
				return {
					token: user.userToken,
					shopId: user.userId,
					appVersion: core.AppVersion,
					salerphone: user.userId,
					__cheniu: {
						core: core,
						user: user
					}
				}
			});
		} else if (is.dafengche()) {
			return jockey__dafengche.getData().then(function (data) {
				return $.when(jockey__cheniu.getUser(), data);
			}).then(function (user, data) {
				return {
					token: data.token,
					shopId: data.reportId,
					appVersion: data.version,
					salerphone: user.userPhone,
					__dafengche: data,
					__cheniu: {
						user: user
					}
				}
			});
		} else if (is.debug__cheniu()) {
			return {
				token: is.debug__cheniu() || 'ab83db41bcd7d726b49f4185d1dd2a77',
				shopId: '18815285492',
				salerphone: '18815285492',
				__cheniu: {
					user: {
						userId: '18815285492',
						userPhone: '18815285491'
					}
				}
			}
		} else if (is.debug__dafengche()) {
			return {
				token: is.debug__dafengche(),
				shopId: '000120',
				salerphone: '18815285492',
				__cheniu: {
					user: {
						userId: 'ABCDEEF',
						userPhone: '18815285492'
					}
				}
			}
		} else {
			return false;
		}
	});
};

function iframeLoad() {
	if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      	var iframe = document.createElement('iframe');
	    iframe.style.display = 'none';
	    iframe.src = '/version.htm?' + Math.random();
	    document.body.appendChild(iframe);
	    iframe.addEventListener('load', function () {
			setTimeout(function () {
				iframe.remove();
			}, 0);
	    });
    }
}

/* @type {Object} */
module.exports = {
	_getData: getData(),

	/** 改变标题 */
	changeTitle: function (title) {
		window.document.title = title;
		iframeLoad();
		if (is.cheniu() || is.dafengche()) {
			jockey__cheniu.setWebViewTitle(title || ' ');
		}
	},

	/** 获取基本信息 */
	getData: function () {
		return this._getData;
	},

	/** 打开一个新的 webView */
	loadH5: function (url, title, carId, hasScore) {
		if (is.cheniu() || is.dafengche()) {
			jockey__cheniu.open(url);
		// } else if (is.dafengche()) {
		// 	jockey__dafengche.loadH5(url, title, carId, hasScore);
		} else {
			window.location.href = url;
		}
	},

	/** 打开一个新的 webview 并监听其关闭事件 */
	loadH5WithOnClose: function (url, callback) {
		if (is.cheniu() || is.dafengche()) {
			jockey__cheniu.openWithOnClose(url, callback);
		} else {
			window.location.href = url;
		}
	},

	/** 关闭当前 vebview */
	close: function (callLaster) {
		if (is.cheniu() || is.dafengche()) {
			jockey__cheniu.close(callLaster);
		}
	},

	/** 关闭并打开 */
	closeThenOpen: function (url, title, carId, hasScore) {
		if (is.cheniu() || is.dafengche()) {
			this.close();
			this.loadH5(url, title, carId, hasScore);
			// jockey__cheniu.closeThenOpen(url);
		// } else if (is.dafengche()) {
		// 	this.loadH5(url, title, carId, hasScore);
		} else {
			window.location.href = url;
		}
	},

	/** 唤起拍照和选择图片控件 */
	capturePic: function (n) {
		if (is.cheniu()) {
			return jockey__cheniu.capturePic(n);
		} else {
			alert('不支持拍照或选择图片');
			return $.when(false);
		}
	},

	/** 唤起拍照 */
	picFromCamera: function () {
		if (is.cheniu()) {
			return jockey__cheniu.picFromCamera();
		} else {
			alert('不支持拍照');
			return $.when(false);
		}
	},

	/** 唤起选择图片 */
	picFromAlbum: function () {
		if (is.cheniu()) {
			return jockey__cheniu.picFromAlbum();
		} else {
			alert('不支持选择图片');
			return $.when(false);
		}
	},

	/** 剪裁图片 */
	cutImage: function (img, w, h) {
		if (is.cheniu() || is.dafengche()) {
			return jockey__cheniu.cutImage(img, w, h);
		}
	},

	/**
	 * 编辑车行信息
	 */
	dealershipInfo: function () {
		if (is.cheniu()) {
			return jockey__cheniu.dealershipInfo();
		} else {
			alert('不支持编辑店铺信息');
		}
	},
	/** 编辑店铺信息 */
	editShopInfo: function () {
		if (is.cheniu()) {
			return jockey__cheniu.editShopInfo();
		} else {
			alert('不支持编辑店铺信息');
		}
	},
	/** 编辑包含店招在内的店铺信息 */
	editShopInfoWithShopsign: function (siteId, shopCode, shopSign) {
		if (is.cheniu()) {
			return jockey__cheniu.editShopInfoWithShopsign(siteId, shopCode, shopSign);
		} else {
			alert('不支持编辑店铺信息');
			return $.when(false);
		}
	},
	/** 触发分享 */
	openShare: function (data) {
		var _data = $.extend({
			title: ' ',
			desc: ' ',
			imgUrl: 'http://img.souche.com/20160322/png/945013b807a289f182ca65e51d0643dc.png@150w_150h_4e_1wh_60Q.jpg',
			link: 'http://d.souche.com'
		}, data);
		if (is.cheniu()) {
			jockey__cheniu.configShare(_data);
			jockey__cheniu.openShare();
		} else if (is.dafengche()) {
			jockey__dafengche.openShare(_data);
		} else if (is.debug__cheniu() || is.debug__dafengche()) {
			console.log('==分享==');
			console.log(data);
		} else {

		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/myjockey/index.js
// module id = 284
// module chunks = 4